export const SERVER_URL = "https://do-calculate.com/api";

export const BMI_EndPoint = "calculate-bmi";
export const BMI_Child_EndPoint = "calculate-child-bmi";
export const Calories_EndPoint = "calculate-calories";
export const BMR_EndPoint = "calculate-bmr";
export const IdealWeight_EndPoint = "calculate-ideal-weight";
export const BodyFat_EndPoint = "calculate-body-fat";
export const FoodEnergy_EndPoint = "calculate-food-energy";
export const WaterIntake_EndPoint = "calculate-water-intake";

export const healthCalculators = [
  // EXISTING CALCULATORS
  {
    name: "Calcul de l'indice de masse corporelle BMI",
    link: "/calculator/fr/bmiadults/",
    description: "Ce calculateur calcule l'indice de masse corporelle (IMC) pour les adultes. Calculez également le poids idéal selon la taille et le poids.",
    showMain: true,
  },
  {
    name: "Calcul de l'indice de masse corporelle BMI pour enfants",
    link: "/calculator/fr/bmichildren/",
    description: "Ce calculateur est utilisé pour calculer l'indice de masse corporelle (IMC) pour les enfants.",
    showMain: true,
  },
  {
    name: "Calculatrice de calories (BMR)",
    link: "/calculator/fr/calories/",
    description:
      "Ce calculateur calcule le nombre de calories quotidiennes requises pour maintenir, augmenter ou perdre du poids.",
    showMain: true,
  },
  {
    name: "Calcul du taux métabolique de base BMR",
    link: "/calculator/fr/bmr/",
    description:
      "Ce calculateur calcule le taux métabolique de base (BMR) qui représente les calories que votre corps a besoin au repos.",
  },
  {
    name: "Calcul du poids idéal pour la taille",
    link: "/calculator/fr/idealweight/",
    description: "Ce calculateur vous aide à calculer le poids idéal qui correspond à votre taille.",
    showMain: true,
  },
  {
    name: "Calcul du pourcentage de graisse corporelle",
    link: "/calculator/fr/bodyfat/",
    description:
      "Ce calculateur est utilisé pour calculer le pourcentage de graisse dans votre corps en fonction de certaines mesures.",
    showMain: true,
  },
  {
    name: "Calcul des glucides dans le corps",
    link: "/calculator/fr/carbohydrate/",
    description: "Aide à calculer la quantité de glucides dont votre corps a besoin quotidiennement.",
  },
  {
    name: "Énergie alimentaire",
    link: "/calculator/fr/foodenergy/",
    description: "Calcule l'énergie ou les calories fournies par les aliments.",
  },
  {
    name: "Calcul des protéines",
    link: "/calculator/fr/protein/",
    description:
      "Calcule la quantité de protéines dont votre corps a besoin selon votre taille, poids et niveau d'activité.",
  },
  {
    name: "Sommeil",
    link: "/calculator/fr/sleep/",
    description:
      "Calcule les heures de sommeil requises selon votre âge.",
  },

  // NEW HEALTH CALCULATORS (35+)
  {
    name: "Calculatrice d'accoutumance",
    link: "/calculator/fr/addiction-calculator/",
    description: "Évalue les niveaux d'accoutumance et fournit des ressources d'aide.",
    showMain: false,
  },
  {
    name: "Calculatrice BAI (Body Adiposity Index)",
    link: "/calculator/fr/bai-calculator/",
    description: "Calcule l'index d'adiposité corporelle (BAI) pour estimer le pourcentage de graisse corporelle.",
    showMain: true,
  },
  {
    name: "Calculatrice de glycémie",
    link: "/calculator/fr/blood-sugar-calculator/",
    description: "Aide à surveiller et calculer les niveaux de sucre dans le sang.",
    showMain: true,
  },
  {
    name: "Calculatrice de type de corps",
    link: "/calculator/fr/body-type-calculator/",
    description: "Détermine le type de corps et donne des recommandations.",
    showMain: true,
  },
  {
    name: "Calculatrice de ratio de cholestérol",
    link: "/calculator/fr/cholesterol-ratio-calculator/",
    description: "Calcule le ratio de cholestérol pour évaluer la santé cardiaque.",
    showMain: true,
  },
  {
    name: "Calculatrice de caféine du café",
    link: "/calculator/fr/coffee-caffeine-calculator/",
    description: "Calcule la quantité de caféine dans votre café.",
    showMain: true,
  },
  {
    name: "Calculatrice du risque de diabète",
    link: "/calculator/fr/diabetes-risk-calculator/",
    description: "Évalue le risque de développer un diabète.",
    showMain: true,
  },
  {
    name: "Test de vision",
    link: "/calculator/fr/eye-test/",
    description: "Teste et évalue votre santé oculaire.",
    showMain: true,
  },
  {
    name: "Calculatrice de forme de visage",
    link: "/calculator/fr/face-shape-calculator/",
    description: "Détermine la forme de votre visage.",
    showMain: false,
  },
  {
    name: "Calculatrice de nutriments alimentaires",
    link: "/calculator/fr/food-nutrients-calculator/",
    description: "Calcule les nutriments contenus dans les aliments.",
    showMain: true,
  },
  {
    name: "Calculatrice de TFG (Débit de filtration glomérulaire)",
    link: "/calculator/fr/gfr-calculator/",
    description: "Calcule le taux de filtration glomérulaire pour la santé rénale.",
    showMain: true,
  },
  {
    name: "Calculatrice de glucose",
    link: "/calculator/fr/glucose-calculator/",
    description: "Aide à surveiller et calculer les niveaux de glucose.",
    showMain: true,
  },
  {
    name: "Calculatrice de fréquence cardiaque",
    link: "/calculator/fr/heartbeat-calculator/",
    description: "Mesure et calcule la fréquence cardiaque.",
    showMain: true,
  },
  {
    name: "Calculatrice de dosage de médicament",
    link: "/calculator/fr/medicine-dosage-calculator/",
    description: "Calcule le dosage correct des médicaments.",
    showMain: false,
  },
  {
    name: "Dosage de paracétamol pour enfants",
    link: "/calculator/fr/paracetamol-children-dosage/",
    description: "Calcule le dosage de paracétamol pour enfants.",
    showMain: true,
  },
  {
    name: "Calculatrice de récupération du tabagisme",
    link: "/calculator/fr/smoking-recovery-calculator/",
    description: "Évalue le temps et les bénéfices de l'abandon du tabagisme.",
    showMain: true,
  },
  {
    name: "Calculatrice de calories des pas",
    link: "/calculator/fr/steps-to-calories-calculator/",
    description: "Convertit le nombre de pas en calories brûlées.",
    showMain: true,
  },
  {
    name: "Calculatrice de calories de marche",
    link: "/calculator/fr/walking-calorie-calculator/",
    description: "Calcule les calories brûlées lors de la marche.",
    showMain: true,
  },
  {
    name: "Calculatrice d'apport en eau",
    link: "/calculator/fr/water-intake-calculator/",
    description: "Calcule la quantité d'eau que vous devez boire quotidiennement.",
    showMain: true,
  },
  {
    name: "Calculatrice de la dose quotidienne de vitamines",
    link: "/calculator/fr/vitamin-daily-dose/",
    description: "Calculez votre dose quotidienne optimale de vitamines essentielles en fonction de votre âge et sexe.",
    showMain: true,
  },
];